__turbopack_context__.v({
  "dark": "SecondaryButton-module-scss-module__kpiwTG__dark",
  "icon": "SecondaryButton-module-scss-module__kpiwTG__icon",
  "iconContainer": "SecondaryButton-module-scss-module__kpiwTG__iconContainer",
  "label": "SecondaryButton-module-scss-module__kpiwTG__label",
  "light": "SecondaryButton-module-scss-module__kpiwTG__light",
  "secondaryButton": "SecondaryButton-module-scss-module__kpiwTG__secondaryButton",
  "stack-module-0": "SecondaryButton-module-scss-module__kpiwTG__stack-module-0",
  "stack-module-1": "SecondaryButton-module-scss-module__kpiwTG__stack-module-1",
  "stack-module-10": "SecondaryButton-module-scss-module__kpiwTG__stack-module-10",
  "stack-module-11": "SecondaryButton-module-scss-module__kpiwTG__stack-module-11",
  "stack-module-12": "SecondaryButton-module-scss-module__kpiwTG__stack-module-12",
  "stack-module-13": "SecondaryButton-module-scss-module__kpiwTG__stack-module-13",
  "stack-module-14": "SecondaryButton-module-scss-module__kpiwTG__stack-module-14",
  "stack-module-15": "SecondaryButton-module-scss-module__kpiwTG__stack-module-15",
  "stack-module-16": "SecondaryButton-module-scss-module__kpiwTG__stack-module-16",
  "stack-module-17": "SecondaryButton-module-scss-module__kpiwTG__stack-module-17",
  "stack-module-18": "SecondaryButton-module-scss-module__kpiwTG__stack-module-18",
  "stack-module-19": "SecondaryButton-module-scss-module__kpiwTG__stack-module-19",
  "stack-module-2": "SecondaryButton-module-scss-module__kpiwTG__stack-module-2",
  "stack-module-20": "SecondaryButton-module-scss-module__kpiwTG__stack-module-20",
  "stack-module-3": "SecondaryButton-module-scss-module__kpiwTG__stack-module-3",
  "stack-module-4": "SecondaryButton-module-scss-module__kpiwTG__stack-module-4",
  "stack-module-5": "SecondaryButton-module-scss-module__kpiwTG__stack-module-5",
  "stack-module-6": "SecondaryButton-module-scss-module__kpiwTG__stack-module-6",
  "stack-module-7": "SecondaryButton-module-scss-module__kpiwTG__stack-module-7",
  "stack-module-8": "SecondaryButton-module-scss-module__kpiwTG__stack-module-8",
  "stack-module-9": "SecondaryButton-module-scss-module__kpiwTG__stack-module-9",
  "z-base": "SecondaryButton-module-scss-module__kpiwTG__z-base",
  "z-content": "SecondaryButton-module-scss-module__kpiwTG__z-content",
  "z-footer": "SecondaryButton-module-scss-module__kpiwTG__z-footer",
  "z-header": "SecondaryButton-module-scss-module__kpiwTG__z-header",
  "z-hero": "SecondaryButton-module-scss-module__kpiwTG__z-hero",
  "z-logo": "SecondaryButton-module-scss-module__kpiwTG__z-logo",
  "z-logo-effect": "SecondaryButton-module-scss-module__kpiwTG__z-logo-effect",
  "z-navigation": "SecondaryButton-module-scss-module__kpiwTG__z-navigation",
  "z-sub": "SecondaryButton-module-scss-module__kpiwTG__z-sub",
});
